module.exports = __webpack_public_path__ + "static/animation-talk-baloon02-41d976683c90c501a2e85bc32ddd7498.png";